<om-label *ngIf="label" [text]="label"></om-label>

<nz-mention #mentions [nzSuggestions]="_suggestions$ | async" nzNotFoundContent="nessun risultato" >
  <input
    [placeholder]="placeholder"
    [formControl]="control"
    nzMentionTrigger
    nz-input
  /> 
</nz-mention>
